// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=local` then `environment.prdecs.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.
const protocol = window.location.protocol;
const domainList = window.location.href.replace('http://', '').replace('https://', '').split('/')[0].split(':')[0].split('.');
const domainPrepix = domainList[0];
domainList[0] = '';
const domain = domainList.join('.');

const alertnowextnPrepix = 'alertnowextndev'; //`${domainPrepix}extn`;
const alertnowextapiPrepix = 'alertnowextapidev'; //`${domainPrepix}extapi`;

const portFlag = window.location.port;
const apiUrl = portFlag !== '' ? `${protocol}//${domainPrepix}${domain}:8080` : `${protocol}//${domainPrepix}${domain}`;



export const environment = {
    production: false,
    envName: 'deveks',
    opsNowUrl : `${protocol}//${domainPrepix}${domain}` + '/',
    apiUrl: `${protocol}//alertnowdev.an.opsnow.com/web`
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts